import new_germany from "../images/newProductPage/languages/DE.png";
import new_spanish from "../images/newProductPage/languages/ES.png";
import new_french from "../images/newProductPage/languages/FR.png";
import new_italy from "../images/newProductPage/languages/IT.png";
import new_niderland from "../images/newProductPage/languages/ND.png";
import new_polish from "../images/newProductPage/languages/PL.png";
import new_portugal from "../images/newProductPage/languages/PR.png";
import new_russia from "../images/newProductPage/languages/RU.png";
import new_england from "../images/newProductPage/languages/UK.png";
import screen1 from "../images/newProductPage/romanian/1.png";
import screen2 from "../images/newProductPage/romanian/2.png";
import screen3 from "../images/newProductPage/romanian/3.png";
import screen4 from "../images/newProductPage/romanian/4.png";

import dlaczego1 from "../images/newProductPage/why/dlaczego_1.webp";
import dlaczego2 from "../images/newProductPage/why/dlaczego_2.webp";
import dlaczego3 from "../images/newProductPage/why/dlaczego_3.webp";
import zdjecie2 from "../images/newProductPage/mission/latop_square.png";
import zdjecie3 from "../images/newProductPage/mission/people_square.png";
import zdjecie1 from "../images/newProductPage/mission/women_square.png";

export const romanian = {
  navbar: {
    data: [
      { title: "Comandă un Curs", path: "/course" },
      { title: "Autentificare", path: "/start" },
      { title: "VorbiGo", path: "/" },
      { title: "Despre Noi", path: "/about" },
      { title: "Păreri", path: "/reviews" },
    ],
  },
  mainPage: {
    product_page: {
      faq: {
        title: "Întrebări frecvente",
        subtitle: "Ai întrebări? Noi avem răspunsurile.",
        sections: [
          {
            title: "Despre VorbiGo",
            questions: [
              {
                question: "Ce este VorbiGo?",
                answer:
                  "VorbiGo este o platformă online pentru învățarea limbilor străine, care îți permite să stăpânești rapid și eficient vorbirea și înțelegerea în practică.",
              },
              {
                question:
                  "Cum funcționează cursurile de limbi străine VorbiGo?",
                answer:
                  "După conectare, primești acces la lecții și materiale interactive online, pe care le poți parcurge oricând îți convine. Cursurile sunt adaptate nivelului și obiectivelor tale.",
              },
              {
                question: "VorbiGo ajută cu adevărat la învățarea vorbirii?",
                answer:
                  "Da. Cursurile noastre se concentrează pe comunicarea practică – datorită exercițiilor interactive, vei depăși rapid teama de a vorbi.",
              },
            ],
          },
          {
            title: "Plăți și livrare",
            questions: [
              {
                question: "Cum pot plăti pentru cursul VorbiGo?",
                answer:
                  "Poți plăti online sau la primirea coletului de la curier (plata ramburs).",
              },
              {
                question: "Sunt datele și plățile mele sigure?",
                answer:
                  "Da. Toate datele sunt protejate conform reglementărilor GDPR, iar plățile – fie online, fie la livrare – sunt securizate și procesate de parteneri de încredere.",
              },
              {
                question: "Când primesc acces la curs după achitarea comenzii?",
                answer:
                  "Accesul se activează automat prin introducerea codului pe pagina indicată.",
              },
              {
                question: "Ce se întâmplă dacă nu ridic coletul",
                answer:
                  " Dacă nu ridici coletul, accesul la curs nu se va activa. Totuși, poți comanda cursul din nou, atunci când îți va conveni.",
              },
            ],
          },
          {
            title: "Siguranță, încredere și asistență",
            questions: [
              {
                question: "Sunt datele mele personale în siguranță la VorbiGo?",
                answer:
                  "Da. VorbiGo este un brand educațional care aparține companiei European Learning Agency, care activează în conformitate cu legea și este înregistrată în Uniunea Europeană. Informații detaliate despre companie și înregistrare găsești în termenii și condițiile disponibile pe site-ul nostru.",
              },
              {
                question: "Este VorbiGo o companie legală și înregistrată?",
                answer:
                  "Jah. VorbiGo on haridusbränd, mis kuulub ettevõttele European Learning Agency. Ettevõte tegutseb seaduslikult ja on registreeritud Euroopa Liidus. Täpsema info leiad meie veebilehel olevatest tingimustest.",
              },
              {
                question:
                  "Cum pot contacta serviciul de asistență clienți VorbiGo?",
                answer:
                  "Poți scrie la adresa bsc@vorbigo-edu.com sau poți folosi formularul de contact disponibil pe site-ul web.",
              },
            ],
          },
        ],
      },
      language: "ro",
      hero: {
        languages: [
          "în engleză",
          "în spaniolă",
          "în germană",
          "în olandeză",
          "în italiană",
          "în rusă",
          "în poloneză",
          "în franceză",
          "în portugheză",
        ],
        title: "Vorbiți mai curajos,",
        prefix: "cu încredere",
        subtitle:
          "Dobândește abilități lingvistice prin cursul nostru bazat pe exemple din viața reală!",
        buttonText: "Comandă acum!",
      },
      learning: {
        title: "Cum arată cursul?",
        config: [
          {
            image: screen1,
            category: "Învață limba în cel mai simplu mod",
            descriptions: [
              {
                bold: "Zeci de lecții",
                rest: "cu exemple bazate pe comunicarea zilnică.",
              },
              {
                bold: "Fraze practice",
                rest: "concepute de vorbitori nativi.",
              },
              {
                bold: "Exerciții,",
                rest: "care dezvoltă eficient cititul, ascultarea și vorbitul.",
              },
            ],
          },
          {
            image: screen2,
            category: "Lecții practice",
            description:
              "Fiecare nivel de învățare este format din zeci de lecții adaptate nevoilor tale.",
          },
          {
            image: screen3,
            category: "Teme",
            description:
              "Exercițiile noastre susțin eficient repetarea materialului și îmbunătățesc memoria.",
          },
          {
            image: screen4,
            category: "Cuvinte, fraze și expresii",
            description:
              "Fiecare lecție include imagini atent selectate, care fac procesul de învățare intuitiv.",
          },
        ],
        photoData: [screen1, screen2, screen3, screen4],
      },
      languages: {
        languages: [
          { image: new_england, lang: "Engleză" },
          { image: new_french, lang: "Franceză" },
          { image: new_spanish, lang: "Spaniolă" },
          { image: new_niderland, lang: "Olandeză" },
          { image: new_germany, lang: "Germană" },
          { image: new_italy, lang: "Italiană" },
          { image: new_russia, lang: "Rusă" },
          { image: new_portugal, lang: "Portugheză" },
          { image: new_polish, lang: "Poloneză" },
        ],
        title: "Limbi disponibile:",
        description:
          "Pregătește-te pentru următoarea călătorie sau adaugă abilități lingvistice în CV-ul tău.",
      },
      expertSection: {
        title: "Expertul tău lingvistic",
        firstSectionTitle: "Suport la îndemână",
        firstSectionDescription: "Primește suport complet pe durata învățării!",
        secondSectionTitle: "Pune întrebări și primește răspunsuri",
        secondSectionDescription:
          "Poți pune orice întrebare direct expertului tău.",
        thirdSectionTitle: "Abordare individuală la fiecare pas",
        thirdSectionDescription:
          "Folosirea sfaturilor expertului lingvistic accelerează procesul tău de învățare.",
      },
      courseValue: {
        title: "Obține mai mult cu VorbiGo",
        subtitle:
          "Nu doar învățarea limbilor – obține acces complet la instrumente.",
        buttonText: "Comandă acum!",
        config: [
          {
            title: "Învățare adaptată stilului tău de viață",
            sections: [
              {
                text: "Învățați oriunde și oricând doriți, datorită platformei noastre.",
              },
              {
                text: "Lecțiile scurte se potrivesc perfect în programul tău zilnic.",
              },
            ],
          },
          {
            title: "Motivație la fiecare pas",
            sections: [
              {
                text: "Păstrează-ți motivația cu sistemul nostru de urmărire.",
              },
              {
                text: "Fiecare zi de învățare te aduce mai aproape de fluență.",
              },
            ],
          },
          {
            title: "Flexibilitate totală și personalizare",
            sections: [
              {
                text: "Adaptează cursul la nivelul tău și ritmul de învățare.",
              },
              {
                text: "Concentrează-te pe ceea ce te interesează cel mai mult.",
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: "Misiune",
      description: `Credem că limba formează un pod între culturi, iar misiunea noastră este să depășim barierele de comunicare și să aducem oamenii împreună prin educație lingvistică.`,
    },
    why: {
      title: "De Ce Noi?",
      config: [
        {
          title: "Metode Educaționale Inovatoare",
          image: dlaczego1,
          description:
            "Algoritmul nostru de învățare sofisticat și testat în practică ajustează materialele la nivelul actual de cunoștințe și îl extinde prin predare eficientă.",
        },
        {
          title: "O Gamă Largă de Limbi",
          image: dlaczego2,
          description:
            "Oferim cursuri în cele mai populare limbi ale lumii. Acest lucru îți permite să alegi limba care se potrivește nevoilor tale.",
        },
        {
          title: "Educație într-un Mod Distractiv",
          image: dlaczego3,
          description:
            "Platforma noastră face învățarea limbilor o experiență distractivă și plăcută, astfel încât vei fi motivat să înveți limbi.",
        },
      ],
    },
    mission: {
      config: [
        {
          title: "Personalizare și Accesibilitate",
          description:
            "Algoritmul nostru eficient de învățare automată lucrează constant pentru a oferi materiale de nivel adecvat pentru fiecare individ. VorbiGo permite cursanților să descopere modele pe cont propriu fără a trebui să se concentreze pe regulile limbii - exact așa cum ai învățat limba maternă în copilărie.",
          image: zdjecie1,
        },
        {
          title: "Combinarea Tehnologiei și Științei",
          description:
            "VorbiGo folosește o combinație îndrăzneață de tehnologie și știință pentru a stimula mintea la acțiune. Repetarea nenumăratelor liste de cuvinte și expresii este plictisitoare, iar creierul tău știe asta. Metoda noastră este captivantă și eficientă, forțându-te să folosești cunoștințele dobândite în diferite moduri în momente specifice - creierul tău va aprecia această soluție!",
          image: zdjecie2,
        },
        {
          title: "Comunitate și Valori",
          description:
            "Limbile ajută oamenii să se angajeze. Învățarea limbilor facilitează înțelegerea. Comunitatea VorbiGo aduce împreună oameni din întreaga lume. Suntem ambițioși și mereu împingem limitele. Credem că învățarea limbilor poate fi distractivă și suntem curioși să explorăm noi culturi prin limbă.",
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: "https://nyelvfejlesztesi-kozpont.eu/",
      title: "Interesat de curs? ",
      title1: "Doriți mai multe informații?",
      subtitle: "Lăsați-vă numărul de telefon - vă vom suna înapoi.",
      subtitle1:
        "Dacă aveți deja un cont, vă rugăm să completați următoarele câmpuri:",
      button1: "Nume și Prenume",
      button2: "Număr de Telefon",
      button3: "Email",
      buttonSub: "Trimite",
      checkOne:
        "Prin trimiterea acestui formular, accept termenii și declar că am citit următorul",
      checkOneTwo: "documentul",
      checkTwo: "Consimt să fiu contactat în scopuri de marketing",
      textOne: "Vă informăm că",
      textTwo:
        "Operatorul datelor dvs. personale este ELA Sp. z o.o., cu sediul în Varșovia, Młynarska 42 / 115, 01-171, înregistrată în registrul antreprenorilor ținut de tribunalul districtual din Varșovia sub KRS5273057993, REGON: 525396900, NIP5273057993. Datele dvs. personale vor fi prelucrate în legătură cu solicitarea formulată prin formularul de contact sau executarea contractului încheiat. Contactându-ne, consimțiți voluntar la prelucrarea datelor dvs. personale în scopurile menționate anterior. Aveți dreptul de a accesa, corecta, șterge sau restricționa prelucrarea datelor dvs., de a vă opune prelucrării și de a portabilității datelor. De asemenea, aveți dreptul de a vă retrage consimțământul în orice moment, dar retragerea consimțământului nu afectează legalitatea prelucrării bazate pe consimțământ înainte de retragerea acestuia. De asemenea, aveți dreptul de a depune o plângere la autoritatea de supraveghere. Furnizarea datelor este voluntară, dar poate fi necesară pentru a răspunde la o solicitare sau pentru executarea unui contract. Datele personale vor fi stocate pentru perioada necesară scopurilor de mai sus, dar nu mai mult decât perioada de prescripție a revendicărilor conform dreptului comun. Vă rugăm să citiți cu atenție politica de confidențialitate",
      buttonMore: "Citește mai mult",
      buttonLess: "Citește mai puțin",
      subOne: "termeni",
      subTwo: "și reguli de confidențialitate.",
      buttonTXT: "Mulțumesc",
      rulesLink: "/Regulations_RO_European_Learning_Agency_vorbigo.pdf",
      privacyLink: "/Privacy_RO_European_Learning_Agency.pdf",
      product: "vro",
      market: "ro",
      send_to_url: "https://crm.eou-edu.eu/api/v1/cms/create_order",
      utm_source: "Platform_Vorbigo",
      product_variant: "ro-en",
      server_link: "https://cms.eou-edu.eu/integration/lead-from-landing",
      currency: "ron",
      price: 390,
    },
  },
  reviews: {
    language: "ro",
    title: "Recenzii VorbiGo",
    subtitle:
      "Părerea ta contează - recenziile VorbiGo ne ajută să dezvoltăm platforma conform nevoilor utilizatorilor.",
    seoText:
      "VorbiGo redefinește standardele educației digitale prin integrarea unei metodologii inovatoare care pune accent pe rezultate concrete și experiența utilizatorului. Platforma noastră a fost creată pentru a răspunde nevoilor academice moderne, oferind un mediu de învățare care combină rigoarea academică cu o interfață intuitivă.",
    contentPlaceholder: "Începe să scrii",
    submitButton: "Trimite",
    thankYouText:
      "Îți mulțumim că îți împărtășești experiența și contribui alături de noi la crearea unui instrument eficient de învățare a limbilor străine!",
    recommendedLabel: "Recomandat",
    items: [
      {
        text: "Metoda de predare este excelentă, mult peste ce am întâlnit pe alte platforme.",
        isRecommended: true,
      },
      {
        text: "Am progresat rapid datorită exercițiilor interactive. Recomand cu încredere oricui vrea rezultate reale.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Platformă foarte intuitivă. M-am acomodat din primele minute fără niciun ajutor.",
        isRecommended: true,
      },
      {
        text: "Suportul tehnic este prompt. Nu m-am simțit nicio secundă singur în acest proces.",
        isRecommended: true,
      },
      {
        text: "Materialele sunt extrem de bine structurate și oferă o perspectivă clară asupra procesului de învățare. Fiecare lecție se leagă logic de cea precedentă, făcând progresul foarte natural și intuitiv. Explicațiile sunt detaliate, iar exemplele practice ajută enorm la fixarea cunoștințelor, transformând studiul într-o experiență plăcută și eficientă pe termen lung.",
        isRecommended: true,
        isTall: true,
      },
      {
        text: "Flexibilitatea este cel mai mare avantaj. Pot studia oricând, oriunde, pe orice dispozitiv.",
        isRecommended: true,
      },
      {
        text: "Designul este odihnitor pentru ochi. Pot petrece ore întregi studiind fără să obosesc.",
        isRecommended: true,
      },
      {
        text: "Am reușit să-mi îmbunătățesc vocabularul într-un timp record. Totul este foarte practic.",
        isRecommended: true,
      },
      {
        text: "O experiență de învățare cu adevărat modernă. M-a ajutat să trec peste frica de a vorbi într-o limbă străină.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Calitatea audio a cursurilor este impecabilă, lucru esențial pentru înțelegerea corectă.",
        isRecommended: true,
      },
      {
        text: "Sistemul de gamificare te motivează să revii zilnic și să progresezi constant.",
        isRecommended: true,
      },
      {
        text: "Este uimitor cum poți vedea progresul vizibil de la o săptămână la alta. Meritâ investiția!",
        isRecommended: true,
      },
      {
        text: "Interfața este curată și fără reclame sau elemente care să te distragă de la studiu.",
        isRecommended: true,
      },
      {
        text: "Comunitatea este foarte activă și primitoare. Găsești mereu răspunsuri la întrebări.",
        isRecommended: true,
      },
    ],
  },
  footer: {
    title: "Alătură-te nouă la:",
    privacy: "Privacy",
    privacyLink: "/Privacy_RO_European_Learning_Agency.pdf",
    rules: "Termeni de serviciu",
    rulesLink: "/Regulations_RO_European_Learning_Agency_vorbigo.pdf",
  },
};
